const backoffs = [0, 500, 1000, 2000, 4000];
const maxAttempts = backoffs.length - 1;

type Arguments = Parameters<typeof fetch>;

export const retryFetch = async (...args: Arguments) => {
	const fetchFunc = () => fetch(...args);

	return retry(fetchFunc, 0);
};

const retry = async (fetchFunc: () => Promise<Response>, attemptCount: number): Promise<Response> => {
	const backoff = backoffs[attemptCount];

	await waitFor(backoff);
	try {
		const response = await fetchFunc();
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
		return response;
	} catch (error) {
		if (attemptCount === maxAttempts) {
			throw error;
		}
		return retry(fetchFunc, attemptCount + 1);
	}
};

const waitFor = (waitTime: number) => {
	return new Promise((resolve) => {
		setTimeout(resolve, waitTime);
	});
};
